import React, {useEffect, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';

// Components
import TextWithLinks from "sharedComponents/TextWithLinks";

// Utils
import validateExplanationField from "utils/validateExplanationField";

// Hooks
import useDropoutSurveyField from "Hooks/useDropoutSurveyField";
import {autoResize} from "Hooks/AutoResizeTextArea";
import {findDOMNode} from "react-dom";


const LongText = ({fieldData, getAnswer, handleChangeSurveyCompletionStatus, mandatoryRefs, disabled = false}) => {
    const longTextRef = useRef();
    const longRef = useRef();
    const [longTextVal, SetLongTextVal] = useState(null);
    const [showError, SetShowError] = useState('');
    const { t } = useTranslation();
    useDropoutSurveyField(longTextVal, '', handleChangeSurveyCompletionStatus);

    useEffect(() => {
        if (getAnswer.constructor !== Boolean) {
            const answer = longTextRef?.current?.value?.trim();

            getAnswer(prevState => ({
                ...prevState,
                [fieldData.id] : {answer, explanation: ""}
            }));
            (!answer?.length && fieldData.mandatory) && SetShowError('Required');
        }
    }, [getAnswer, fieldData]);

    useEffect(() => {
        const fieldNode = findDOMNode(longRef.current);
        if (fieldData.mandatory) {
            if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                mandatoryRefs.push(fieldNode);
            }
        }
    }, [fieldData]);

    const handleChange = (e) => {
        SetLongTextVal(e.target.value);
        SetShowError(validateExplanationField(e.target.value, fieldData.mandatory, 'larger'));
        autoResize(longTextRef);

        if (!e?.target?.value) {
            const fieldNode = findDOMNode(longRef.current);
            if (fieldData.mandatory) {
                if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                    mandatoryRefs.unshift(fieldNode);
                }
            }
        }
    };

    return (
        <div
            ref={longRef}
            className={`single_sect ${showError ? "invalid" : ""}`}>
            <h3 className="single_sect_primary_text">
                {fieldData.label}
                {!!fieldData.mandatory && <sup>*</sup>}
            </h3>
            <TextWithLinks className="single_sect_secondary_text">
                {fieldData.description}
            </TextWithLinks>
            <div className="input_field">
                <textarea
                    defaultValue={fieldData?.answers?.answer}
                    ref={longTextRef}
                    name="long_text"
                    placeholder={t("Please add an answer")}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>
            <div className="error_sect">
                {showError}
            </div>
        </div>
    )
}

export default React.memo(LongText);
